import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const closingAttorneyContactCard = buildAdditionalContactCard({
  contactType: 'closingAttorney',
  contactLabel: 'Closing Attorney',
  overrides: {
    addByDefault: true,
    hideByDefault: false,
    fields: {
      role: {
        label: 'Role',
        placeholderText: 'Attorney, Assistant, etc',
      },
    },
  } satisfies ContactCardOverrides,
});
